import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { JobDetail } from 'src/app/shared/models/gql/job-detail.model';

@Component({
  selector: 'app-flex-job-date-time',
  templateUrl: './flex-job-date-time.component.html',
  styleUrls: ['./flex-job-date-time.component.scss'],
})
export class FlexJobDateTimeComponent implements OnInit {
  @Input() job: JobDetail;

  @Input() detailed = false;

  isSameDay = false;

  format = 'LT, ddd DD MMM';

  public dateOnlyFormat: any = {
    sameDay: '[Today,] ddd DD MMM',
    lastDay: '[Yesterday,] ddd DD MMM',
    lastWeek: 'ddd DD MMM',
    sameElse: 'ddd DD MMM',
    nextDay: '[Tomorrow,] ddd DD MMM',
    nextWeek: 'ddd DD MMM',
  };

  ngOnInit() {
    this.isSameDay =
      moment(this.job?.timestamps?.startTime).format('ddd DD MMM') ===
      moment(this.job?.timestamps?.endTime).format('ddd DD MMM');
  }

  getCombinedDate(date: string) {
    return moment(date).format(this.format);
  }

  getTime(date: string) {
    return moment(date).format('LT');
  }
}
